import types from "rdx/modules/homeowner/types";
import createAction from "rdx/utils/createAction";

export default {
  verifyHomeownerContact: (payload) => createAction(types.VERIFY_HOMEOWNER_CONTACT, payload),
  // INSERTION_PT (for script, do not remove)
};
